import { FileText } from 'lucide-react';
import { LucideIcon } from 'lucide-react';
import { routesMap } from '../../routes/routesMap';

export interface ConductRiskCard {
  title: string;
  description: string;
  link: string;
  icon: LucideIcon;
  label: string;
}

export const CONDUCT_RISK_CARDS: ConductRiskCard[] = [
  {
    title: "Report",
    description: "In questa sezione è possibile visualizzare la lista report di Conduct Risk.",
    link: routesMap.CONDUCT_RISK_REPORT_PAGE,
    icon: FileText,
    label: "Sezione",
  },
];
